export function decodeShopifyIdFromGraphqlIdResponse(graphqlIdResponse?: string | undefined | null | number) {
  if (!graphqlIdResponse) {
    return undefined
  }
  return `${graphqlIdResponse}`.split('/').pop()
}
